import { CheckStatus, Parse } from '../utils/ajax';

export default {

    getAssets(tenantId, authToken) {
        return fetch('/api/draw/1/assets', {
            headers: {
                ManyWhoTenant: tenantId,
                Authorization: authToken,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    createFolder() {
        return true;
    },

    deleteAsset(tenantId, authToken, payload) {
        return fetch('/api/draw/1/assets', {
            method: 'DELETE',
            headers: {
                ManyWhoTenant: tenantId,
                Authorization: authToken,
                'Content-Type': 'application/json',
            },
            body: payload,
        })
            .then(CheckStatus);
    },

    moveAsset(tenantId, authToken, payload) {
        return fetch('/api/draw/1/assets', {
            method: 'PUT',
            headers: {
                ManyWhoTenant: tenantId,
                Authorization: authToken,
                'Content-Type': 'application/json',
            },
            body: payload,
        })
            .then(CheckStatus);
    },

    uploadAsset(endpoint, tenantId, authToken, payload) {
        return fetch(endpoint, {
            method: 'PUT',
            body: payload,
        })
            .then(CheckStatus);
    },

    createAsset(tenantId, authToken, payload) {
        return fetch('/api/draw/1/assets/upload', {
            method: 'POST',
            headers: {
                ManyWhoTenant: tenantId,
                Authorization: authToken,
                'Content-Type': 'application/json',
            },
            body: payload,
        })
            .then(CheckStatus)
            .then(Parse);
    },

};
